import { render, staticRenderFns } from "./ArticleLayout.vue?vue&type=template&id=138ec5d6&"
import script from "./ArticleLayout.vue?vue&type=script&lang=js&"
export * from "./ArticleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports